export default __webpack_public_path__ + "static/media/d1.0f369baa.png";